import React, { useState, useEffect } from 'react';
import Layout from '../../components/layout/Layout';
import balanceContadorService from '../../services/balanceContadorService';
import { formatearMoneda } from '../../utils/helpers';
import { FaArrowUp, FaArrowDown, FaChartLine } from 'react-icons/fa';

const MESES = [
  'Enero','Febrero','Marzo','Abril','Mayo','Junio',
  'Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'
];

export default function BalanceContadorPage() {
  const [balance,  setBalance]  = useState([]);
  const [cargando, setCargando] = useState(true);
  const [anio,     setAnio]     = useState(new Date().getFullYear());
  const [mes,      setMes]      = useState(new Date().getMonth() + 1);

  useEffect(() => { cargarBalance(); }, [anio, mes]);

  const cargarBalance = async () => {
    setCargando(true);
    try {
      const data = await balanceContadorService.obtener(anio, mes);
      setBalance(data);
    } finally {
      setCargando(false);
    }
  };

  return (
    <Layout>
      <div className="page-header d-flex justify-content-between align-items-center">
        <div>
          <h4>Balance del Contador</h4>
          <p>Movimientos registrados por contadores en tiempo real</p>
        </div>
        <div className="d-flex gap-2">
          <select
            className="form-select form-select-sm"
            value={mes}
            onChange={(e) => setMes(Number(e.target.value))}
          >
            {MESES.map((m, i) => (
              <option key={i} value={i + 1}>{m}</option>
            ))}
          </select>
          <select
            className="form-select form-select-sm"
            value={anio}
            onChange={(e) => setAnio(Number(e.target.value))}
          >
            {[2024, 2025, 2026].map((a) => (
              <option key={a} value={a}>{a}</option>
            ))}
          </select>
        </div>
      </div>

      {cargando ? (
        <div className="text-center py-4">
          <div className="spinner-custom mx-auto" />
        </div>
      ) : balance.length > 0 ? (
        balance.map((b, i) => (
          <div key={i} className="card card-custom mb-3">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <div>
                  <h6 className="fw-bold mb-0">{b.contador}</h6>
                  <small className="text-muted">{b.email}</small>
                </div>
                <span className={`badge ${b.saldo_neto >= 0 ? 'bg-success' : 'bg-danger'}`}>
                  {b.saldo_neto >= 0 ? 'Estable' : 'Inestable'}
                </span>
              </div>

              <div className="row g-3">
                <div className="col-12 col-sm-6 col-xl-4">
                  <div className="p-3 rounded"
                    style={{ background: 'rgba(39,174,96,0.1)', borderLeft: '4px solid #27AE60' }}>
                    <div className="d-flex align-items-center gap-2 mb-1">
                      <FaArrowUp color="#27AE60" />
                      <small className="text-muted">Ingresos</small>
                    </div>
                    <div className="fw-bold text-success fs-5">
                      {formatearMoneda(b.ingresos)}
                    </div>
                  </div>
                </div>

               <div className="col-12 col-sm-6 col-xl-4">
                  <div className="p-3 rounded"
                    style={{ background: 'rgba(231,76,60,0.1)', borderLeft: '4px solid #E74C3C' }}>
                    <div className="d-flex align-items-center gap-2 mb-1">
                      <FaArrowDown color="#E74C3C" />
                      <small className="text-muted">Gastos</small>
                    </div>
                    <div className="fw-bold text-danger fs-5">
                      {formatearMoneda(b.gastos)}
                    </div>
                  </div>
                </div>

                <div className="col-12 col-sm-6 col-xl-4">
                  <div className="p-3 rounded"
                    style={{
                      background: b.saldo_neto >= 0
                        ? 'rgba(26,82,118,0.1)'
                        : 'rgba(231,76,60,0.1)',
                      borderLeft: `4px solid ${b.saldo_neto >= 0 ? '#1A5276' : '#E74C3C'}`
                    }}>
                    <div className="d-flex align-items-center gap-2 mb-1">
                      <FaChartLine color={b.saldo_neto >= 0 ? '#1A5276' : '#E74C3C'} />
                      <small className="text-muted">Saldo Neto</small>
                    </div>
                    <div className={`fw-bold fs-5 ${b.saldo_neto >= 0 ? 'text-primary' : 'text-danger'}`}>
                      {formatearMoneda(b.saldo_neto)}
                    </div>
                  </div>
                </div>
              </div>

              {b.ingresos > 0 && (
                <div className="mt-3">
                  <div className="d-flex justify-content-between small text-muted mb-1">
                    <span>Proporción Gastos/Ingresos</span>
                    <span>{((b.gastos / b.ingresos) * 100).toFixed(1)}%</span>
                  </div>
                  <div className="progress" style={{ height: '8px' }}>
                    <div
                      className={`progress-bar ${b.gastos > b.ingresos ? 'bg-danger' : 'bg-success'}`}
                      style={{
                        width: `${Math.min((b.gastos / b.ingresos) * 100, 100)}%`,
                        borderRadius: '6px'
                      }}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        ))
      ) : (
        <div className="card card-custom">
          <div className="card-body text-center py-5 text-muted">
            Sin contadores activos registrados
          </div>
        </div>
      )}
    </Layout>
  );
}